import axios from "axios";
import { API_URL } from "../../env";
import { paserParams } from "../../until";
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";
import { SortType } from "../carLine/carLineApi";
import { ITag } from "../selectOption/selectOptionsApi";
import tokenService from '../../services/token';

export interface ICar {
  id: number
  title: string
  code: string
  image: string
  yearCreate: number | null
  seatingCapacity: number
  categoryCar: string
  categoryCarImage: string
  carLines: string
  typeVehicle: string
  version: string
  segmentsVehicle: string
  fuel: string
  color: string
  modelVehicle: string
  typeBodyVehicle: string
  codeB7?: string
  groupVehicleTitle?: string
  modelVehicleTitle?: string
}
export interface ICarEdit {
  id: number
  title: string
  countryId: any
  country: string
  code: string
  carImage: string
  yearCreate: number
  categoryCarId: number
  categoryCar: string
  categoryCarImage: string
  carLinesId: number
  carLines: string
  typeVehicleId: number
  typeVehicle: string
  seatingCapacity: any
  fuelId: any
  fuel: string
  segmentsVehicleId: number
  segmentsVehicle: string
  colorId: any
  color: string
  groupColorId: any
  groupColorTitle: string
  bodyVehicleId: any
  bodyVehicle: string
  typeBodyVehicleId: any
  typeBodyVehicle: string
  groupVehicleId: number
  groupVehicleTitle: string
  productVehicleId: number
  productVehicleTitle: string
  modelVehicleId: number
  modelVehicleTitle: string,
  codeB7?: string
}
export interface ICarEdit2 {
  categoryCarId?: number
  carLinesId?: number
  typeVehicleId?: number
  colorId?: number
  groupColorId?: number
}
export interface FilterCar {
  search?: string
  categoryCarId?: number
  typeVehicleId?: number
}


//Danh sách xe
export const getListCar = async (
  limit?: number, pageNumber?: number, search?: string, typeVehicleId?: number, categoryCarId?: number
) => {
  const path = "car/listCar"
  const params = {
    limit, pageNumber, search, typeVehicleId, categoryCarId
  }
  const result: ResponseSuccessTotal<ICar[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Thông tin xe
export const getInfoCar = async (
  id: number
) => {
  const path = "car/infoCar"
  const params = {
    id
  }
  const result: ResponseSuccessTotal<ICarEdit> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Thêm mới xe
export const addCar = async (
  title: string, code: string, idCarLines: number, idTypeVehicle: number,
  idCategoryCar: number, idModelVehicle: number, idSegmentsVehicle: number,
  image: File, yearCreate?: number,
  idGroupVehicle?: number, idProductVehicle?: number, seatingCapacity?: number, idFuel?: number,
  idColor?: number, idGroupColor?: number, idBodyVehicle?: number, idTypeBodyVehicle?: number,
  idCountry?: number, codeB7?: string
) => {
  const url = "car/addCar";
  const params = {
    title, code, idCarLines, idTypeVehicle,
    idCategoryCar, idModelVehicle, idSegmentsVehicle, yearCreate,
    image,
    idGroupVehicle, idProductVehicle, seatingCapacity, idFuel,
    idColor, idGroupColor, idBodyVehicle, idTypeBodyVehicle,
    idCountry, codeB7
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, params
  );
  return result;
}

//Chỉnh sửa xe
export const editCar = async (
  id: number, title: string, code: string, idCarLines: number,
  idTypeVehicle: number, idCategoryCar: number, idModelVehicle: number, idSegmentsVehicle: number, image: File,
  yearCreate?: number,
  idGroupVehicle?: number, idProductVehicle?: number, seatingCapacity?: number, idFuel?: number,
  idColor?: number, idGroupColor?: number, idBodyVehicle?: number, idTypeBodyVehicle?: number,
  idCountry?: number, codeB7?: string
) => {
  const url = "car/editCar";
  const params = {
    id, title, code, idCarLines,
    idTypeVehicle, idCategoryCar, idModelVehicle, idSegmentsVehicle,
    yearCreate, image,
    idGroupVehicle, idProductVehicle, seatingCapacity, idFuel,
    idColor, idGroupColor, idBodyVehicle, idTypeBodyVehicle,
    idCountry, codeB7
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, params
  );
  return result;
}

//Xóa xe
export const deleteCar = async (
  id: Number
) => {
  const url = "car/deleteCar";
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    url, { params }
  );
  return result;
}


export interface ICarCustomer {
  vehicleChassisNo: ITag[]
  plateNumber: string
  plateNumberId: number
}

//Thông tin xe
export const getInfoCarCustomer = async (
  vehicleId: number, idCustomer: number
) => {
  const path = "/car/infoCarCustomer"
  const params = {
    vehicleId, idCustomer
  }
  const result: ResponseSuccess<ICarCustomer> = await axiosClient.get(
    path, { params }
  );
  return result;
};


// Xuất ds xe
export const exportListCustomerExcel = async (
    search?: string,
    categoryCarId?: number,typeVehicleId?: number, carLinesId?: number,  segmentsVehicleId?: number,
    yearCreate?: number,
) => {
    try {
        // 1. Kiểm tra URL
        const token = tokenService.getToken()
        const apiUrl = `${API_URL}${"car/exportExcel"}`

        const response = await axios.get(apiUrl, {
            params: {
                search, categoryCarId, typeVehicleId, carLinesId, segmentsVehicleId, yearCreate
            },
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });

        if (response.status === 200 && response.data) {
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Danh sách xe.xlsx`;
            a.click();
        }

    } catch (error) {
        console.error('Error:', error);
    }

};
